import React, { Component } from 'react'
import i18n from '../i18n.json'

class About extends Component {
  renderNav() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="nav">
        <ul>
          <li className="left-corner">
            <a id="automagic-logo" href="/">
              automagic<br />.design
            </a>
          </li>
          <li>
              <a href="/">
                <div className="padding-bottom">
                  <h2><i className="fa fa-plus-square-o"></i></h2>
                  { i18n[selectedLanguage]['dashboard-menu-new-logo'] }
                </div>
              </a>
          </li>
        </ul>

      </div>
    )
  }

  renderContent() {
    return (
      <div className="fullpage">
        <div className="row">

           <div className="col-6 page-description">
            <h1 style={{ color: 'rgba(0, 0, 0, 0.3)'}}>We are your automatic design studio.</h1>
            <h1>We use Artificial Intelligence to make design simple, affordable and beautiful.</h1>
            <h1 style={{ color: 'rgba(0, 0, 0, 0.3)'}}>Like magic</h1>
           </div>

           <div className="col-6 page-content page-about">
      <p><b>Automagic Design</b> is designed and engineered by <a href="http://cod.ai">Codai</a>, a
      bootstrapped software company created by a couple of computer engineers and artists with
      the goal of creating simple, beautiful, and robust sustainable solutions.</p><br />
<p>We are creating
                  an autonomous platform that reduces the time spent by users to create
                  any design project. That's why we can deliver faster and 5-10x cheaper than
                  competitors. <br /> <br/>  We're starting with logos, but our mission is to become your automatic design and generative studio.
      <br /><br />
      </p>
      <div className="row">
          <div className="col-6">
            <h1>Gabriela Salvador</h1>
          <p><a href="http://instagram.com/gabithume">
            <i className="fa fa-instagram fa-fw"></i> 
            Instagram
          </a> &nbsp; &nbsp;
          <a href="http://github.com/gabithume">
            <i className="fa fa-github fa-fw"></i> 
            Github
          </a><br /><br /></p>
          <p>Computer scientist who has being working for Mozilla
          and The Grid. During her MSc at ICMC/USP she researched Computer Vision and
          Machine Learning. Her main interests are Artificial Intelligence and
          Open Source Software engineering. For her eager to solve problems she
          received the title of <i>bug squasher machine</i>.</p>

          </div>
          <div className="col-6">
            <h1>Vilson Vieira</h1>
          <p><a href="http://twitter.com/aut0mata">
            <i className="fa fa-twitter fa-fw"></i> 
            Twitter
          </a> &nbsp; &nbsp;
          <a href="http://github.com/automata">
            <i className="fa fa-github fa-fw"></i> 
            Github
          </a><br /><br /></p>
          <p>Coder and artist. Has being working for Google and
          The Grid. Researched Computational Creativity, Computer Vision and
          Computational Music during his MSc at Applied Physics on IFSC/USP. His main
          interests are Artificial Intelligence and Visual Programming. He also
          likes to draw and compose Electronic Music in computers and old Game Boys.</p>

          </div>

      </div>
           </div>

        </div>
      </div>
    )
  }

  renderBottom() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
        <div>
         <div className="bottom bottom-left">
          <a href="/about">{ i18n[selectedLanguage]['bottom-about'] }</a> |
          <a href="/pricing"> { i18n[selectedLanguage]['bottom-pricing'] }</a> |
          <a href="mailto:contact@automagic.design"> { i18n[selectedLanguage]['bottom-contact'] }</a> |
          <a href="/tos"> { i18n[selectedLanguage]['bottom-tos'] }</a> |
          <a href="/privacy"> { i18n[selectedLanguage]['bottom-privacy'] }</a>
         </div>
         { /*
         <div className="bottom bottom-right">
          <a className="language-selector" href="/en" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('en') } }> EN</a> |
          <a className="language-selector" href="/pt" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('pt') } }> PT-BR</a>
         </div>
         */ }
        </div>
    )
  }

  render() {
    return (
      <div>
        { this.renderNav() }

        { this.renderContent() }

        { this.renderBottom() }
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/About.js